function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

function formatDate(value, locale = "en-GB") {
  if (!/^\d{4}-\d{2}-\d{2}/.test(String(value || ""))) return value;
  const parsed = new Date(String(value).slice(0, 10) + "T12:00:00Z");
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat(locale, {
    day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
  }).format(parsed);
}

export default function EditorialArticleHero({
  article, title, subtitle, category, topicTag, author, id, className = "",
}) {
  if (!article && !title) return null;
  const locale = article?.hreflang || article?.locale || "en-GB";
  const labels = {
    fr: { metadata: "Informations sur l’article", by: "Par", published: "Publié le", updated: "Mis à jour le" },
    de: { metadata: "Angaben zum Artikel", by: "Von", published: "Veröffentlicht am", updated: "Aktualisiert am" },
    es: { metadata: "Información del artículo", by: "Por", published: "Publicado el", updated: "Actualizado el" },
    pt: { metadata: "Informações do artigo", by: "Por", published: "Publicado em", updated: "Atualizado em" },
    ja: { metadata: "記事情報", by: "執筆", published: "公開日", updated: "更新日" },
    "zh-cn": { metadata: "文章信息", by: "作者", published: "发布日期", updated: "更新日期" },
  }[locale.toLowerCase()] || { metadata: "Article metadata", by: "By", published: "Published", updated: "Updated" };
  const resolvedTitle = title || article?.heroTitle || article?.headline || article?.title;
  const resolvedSubtitle = subtitle || article?.heroSubtitle || article?.subtitle || article?.description;
  const resolvedCategory = category || article?.competitionBadge || article?.category || "Article";
  const resolvedAuthor = author || article?.authorName || article?.author || "TechniaHQRobot";
  const publishedDate = article?.datePublished;
  const updatedDate = article?.dateModified;
  const showUpdatedDate = Boolean(updatedDate) && normalize(updatedDate) !== normalize(publishedDate);
  const resolvedTopic = [topicTag, article?.topicTag, ...(article?.tags || [])].find((item) =>
    String(item || "").trim() && normalize(item) !== normalize(resolvedCategory) && String(item).length <= 40
  );

  return (
    <header id={id} className={"editorial-article-header " + className}>
      <div className="editorial-article-header__labels">
        <span className="editorial-article-header__category">{resolvedCategory}</span>
        {resolvedTopic && <span className="editorial-article-header__topic">{resolvedTopic}</span>}
      </div>
      <h1 className="article-title">{resolvedTitle}</h1>
      {resolvedSubtitle && <p className="editorial-article-header__summary">{resolvedSubtitle}</p>}
      <div className="editorial-article-header__meta" aria-label={labels.metadata}>
        {resolvedAuthor && <span className="editorial-article-header__author">{labels.by} <span>{resolvedAuthor}</span></span>}
        {publishedDate && <time dateTime={publishedDate} aria-label={labels.published + " " + formatDate(publishedDate, locale)}>{formatDate(publishedDate, locale)}</time>}
        {showUpdatedDate && <time dateTime={updatedDate}>{labels.updated} {formatDate(updatedDate, locale)}</time>}
        {article?.readingTime && <span>{article.readingTime}</span>}
      </div>
    </header>
  );
}
